import React, {useEffect} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {ErrorMessage, Form, Formik} from "formik";
import * as Yup from "yup";
import { loginRequest } from '../../store/auth/actions';
import loginImg from "../../assets/images/illustration.svg";
import logoImgPoste from "../../assets/images/logo-poste-ci.png";

import {StyledError} from "../../components/StyledErro";
import '../../assets/css/app.css';
const LoginValidationSchema = Yup.object().shape({
    email: Yup.string().required('L\'adresse mail est requis'),
    password: Yup.string().required('Le mot de passe est requis'),
});

const SignupForm = () => {

    const history=useNavigate();

    const dispatch = useDispatch();
    // @ts-ignore
    const _loginState = useSelector(state => state.auth)

    const initialValues = {
        email:'',
        password:''
    };

    const handleSubmit = async ( values) => {
        dispatch(loginRequest(values,history))
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={LoginValidationSchema}
        >
            {({
                  values,
                  handleChange,
                  handleBlur,
                  isSubmitting,
              }) => (
                <Form id="loginForm">
                    <h2 className="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
                        Connectez-vous !
                    </h2>
                    <div className="intro-x mt-2 text-gray-500 xl:hidden text-center">
                        Quelques clics de plus pour vous connecter à votre compte.
                        Gérez tous vos comptes de commerce électronique en un seul endroit
                    </div>
                    <div className="intro-x mt-8">
                        <input  className="intro-x login__input input input--lg border border-gray-300 block"
                               id="email"
                               name="email"
                                type="email"
                               onBlur={handleBlur}
                               onChange={handleChange}
                               value={values.email}
                               placeholder="Email"
                                required/>
                        <ErrorMessage name='email' component={StyledError} />

                    </div>

                    <div className="intro-x mt-8">
                        <input  className="intro-x login__input input input--lg
                border border-gray-300 block mt-4"
                               id="password"
                               name="password"
                               type="password"
                               onBlur={handleBlur}
                               onChange={handleChange}
                               value={values.password}
                               placeholder="Mot de passe"
                                required/>
                        <ErrorMessage name='password' component={StyledError} />
                    </div>
                    <div className="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-4">
                        <div className="flex items-center mr-auto">
                            <input type="checkbox" className="input border mr-2" id="remember-me" />
                            <label className="cursor-pointer select-none" htmlFor="remember-me">
                                Se souvenir de moi
                            </label>
                        </div>
                        <Link to="/">Mot de passe oublié?</Link>
                    </div>
                    <div className="intro-x mt-5 xl:mt-8 text-center xl:text-center">
                        <button className="button button--lg w-full xl:w-full text-white
                bg-theme-1 align-top" type="submit" disabled={_loginState.isLoading}>
                            {_loginState.isLoading ? "Chargement": "Connexion"}
                        </button>
                    </div>
                    <div className="intro-x mt-10 xl:mt-24 text-gray-700 dark:text-gray-600 text-center xl:text-left">
                        En vous connectant vous acceptez nos
                        <br />
                        <Link className="text-theme-1 dark:text-theme-10" to="/">
                            Conditions d'uilisations
                        </Link> & <Link className="text-theme-1 dark:text-theme-10" href="/">
                        Politique de confidentialité</Link>
                    </div>
                </Form>
            )}
        </Formik>
    );

};
// @ts-ignore
function Login() {

    useEffect(() => {
        window.document.body.className = 'login';
        return () => {
            window.document.body.className = 'app';
        }
    }, [])

    return (
        <div>
            <div className="container sm:px-10">
                <div className="block xl:grid grid-cols-2 gap-4">
                    <div className="hidden xl:flex flex-col min-h-screen">
                        <span className="-intro-x flex items-center pt-5">
                            <img alt="Midone Tailwind HTML Admin Template"
                                 className="w-13" src={logoImgPoste} />
                        </span>
                        <div className="my-auto">
                            <img alt="Midone Tailwind HTML Admin Template"
                                 className="-intro-x w-1/2 -mt-16" src={loginImg} />
                            <div className="-intro-x text-white font-medium text-4xl leading-tight mt-10">
                                Quelques clics de plus pour vous
                                <br />
                                connecter à votre compte.
                            </div>
                            <div className="-intro-x mt-5 text-lg text-white dark:text-gray-500">
                                Gérez tous vos comptes de commerce électronique en un seul endroit
                            </div>
                        </div>
                    </div>
                    <div className="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
                        <div className="my-auto mx-auto xl:ml-20 bg-white xl:bg-transparent px-5
                        sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4
                        lg:w-2/4 xl:w-auto">

                            <SignupForm/>
{/*                            <Components.ErrorMessages>
                               {errorMessages}
                            </Components.ErrorMessages>
                            <Components.LoginForm email={email} setEmail={setEmail}
                                                  Password={Password} setPassword={setPassword} isDisabled={isDisabled}
                                                  handleSubmit={()=>null}/>*/}
                        </div>
                    </div>
                </div>
            </div>
            {/*<SignupForm/>*/}
        </div>
    );
}

export default Login;
